import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Award } from "lucide-react";

// Menampilkan ekskul & progsus siswa (pendamping + riwayat nilai) di modal Detail Siswa.
// Dipakai oleh Admin (SiswaDetailModal), Kepsek (DataSiswa → modal yang sama), dan Guru (ProfilPendampingan).
export function SiswaEkskulSection({ siswaId }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!siswaId) return;
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get(`/ekskul-progsus/siswa/${siswaId}`);
        if (!cancelled) setData(data);
      } catch (_) { if (!cancelled) setData({ ekskul: [], progsus: [] }); }
    })();
    return () => { cancelled = true; };
  }, [siswaId]);

  if (!data) return null;
  const hasAny = (data.ekskul?.length || 0) + (data.progsus?.length || 0) > 0;

  const Group = ({ title, items }) => (
    <div>
      <div className="text-xs uppercase text-slate-500 font-semibold mb-2">{title}</div>
      {items.length === 0
        ? <div className="text-sm text-slate-400 italic">Tidak terdaftar.</div>
        : <div className="space-y-2">
            {items.map((it) => {
              const last = it.nilai?.[0];
              return (
                <div key={it.jenis} className="rounded-lg border border-slate-200 p-3" data-testid={`siswa-ep-${it.jenis}`}>
                  <div className="flex items-center justify-between gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-slate-900">{it.jenis.replace(/^(Ekskul|Progsus)\s+/, "")}</span>
                    <span className="text-xs text-slate-500">Pendamping: {it.nama_guru}</span>
                  </div>
                  {last && (
                    <div className="mt-1.5 text-xs text-slate-600">
                      Nilai terbaru ({last.semester} {last.tahun}): <b className="text-slate-900">{last.nilai}</b>
                      {last.deskripsi && <span className="text-slate-500"> — {last.deskripsi}</span>}
                    </div>
                  )}
                </div>
              );
            })}
          </div>}
    </div>
  );

  return (
    <div className="mt-5 pt-5 border-t border-slate-200" data-testid="siswa-detail-ekskul">
      <div className="flex items-center gap-2 mb-3">
        <Award className="w-4 h-4 text-indigo-600" />
        <h4 className="font-semibold text-slate-900">Ekstrakurikuler & Progsus</h4>
      </div>
      {!hasAny
        ? <div className="text-sm text-slate-400 italic">Siswa belum terdaftar di ekskul/progsus manapun.</div>
        : <div className="grid sm:grid-cols-2 gap-5">
            <Group title="Ekstrakurikuler" items={data.ekskul} />
            <Group title="Program Khusus" items={data.progsus} />
          </div>}
    </div>
  );
}
